angular

	.module 'App.Repository'
	.factory 'StockValueRepository', ['BaseRepository', (BaseRepository) ->
		class StockValueRepository extends BaseRepository
			@resource = '/stock_values'
			@isRestricted = true

		return new StockValueRepository
	]
